/* Kosmyk: galeria, kolory, zestawy, dodawanie do koszyka, zakładki. */
(function () {
  const zl = (cents) => {
    const v = Math.round(cents) / 100;
    return (Number.isInteger(v) ? String(v) : v.toFixed(2).replace('.', ',')) + ' zł';
  };

  function initProduct(root) {
    const dataEl = root.querySelector('[data-km-data]');
    if (!dataEl) return;
    const D = JSON.parse(dataEl.textContent);
    const V = D.variants;
    let color = Math.max(0, V.findIndex((v) => v.id === D.defaultColor));
    let offer = D.defaultOffer || 0;
    let picks = [color, color, color, color];

    const gal = root.querySelector('[data-km-gallery]');
    const thumbs = root.querySelector('[data-km-thumbs]');
    const sws = root.querySelector('[data-km-swatches]');
    const offs = root.querySelector('[data-km-offers]');
    const pk = root.querySelector('[data-km-picks]');
    const err = root.querySelector('[data-km-err]');
    const sticky = root.querySelector('[data-km-sticky]');

    const go = (i) => gal.scrollTo({ left: i * gal.clientWidth, behavior: 'smooth' });
    [...thumbs.children].forEach((b, i) => b.addEventListener('click', () => go(i)));
    const mark = () => {
      const i = Math.round(gal.scrollLeft / Math.max(1, gal.clientWidth));
      [...thumbs.children].forEach((b, j) => b.setAttribute('aria-current', String(i === j)));
    };
    gal.addEventListener('scroll', mark, { passive: true });
    mark();

    V.forEach((v, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'km-sw';
      b.setAttribute('aria-label', v.name);
      b.innerHTML = '<i style="background:' + v.hex + '"></i>';
      b.addEventListener('click', () => {
        color = i;
        picks = picks.map(() => i);
        const slot = gal.children[1];
        if (slot && v.img) {
          slot.removeAttribute('srcset');
          slot.src = v.img;
          const t = thumbs.children[1] && thumbs.children[1].querySelector('img');
          if (t) { t.removeAttribute('srcset'); t.src = v.img; }
          go(1);
        }
        render();
      });
      sws.appendChild(b);
    });

    D.offers.forEach((o, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'km-offer';
      b.setAttribute('role', 'radio');
      b.innerHTML =
        (o.rib ? '<span class="km-ribbon">' + o.rib + '</span>' : '') +
        '<span class="km-dot"></span><span><span class="km-offer__t">' + o.t + '</span><span class="km-offer__d">' + o.d + '</span>' +
        (o.save ? '<span class="km-offer__save">Oszczędzasz ' + zl(o.save) + ' · darmowa dostawa</span>' : '') +
        '</span><span class="km-offer__p">' + (o.q > 1 ? '<s>' + zl(D.single * o.q) + '</s>' : '') + '<b>' + zl(o.p) + '</b><small>' +
        (o.q > 1 ? zl(o.p / o.q) + ' / szt.' : '+ dostawa') + '</small></span>';
      b.addEventListener('click', () => { offer = i; render(); });
      offs.appendChild(b);
    });

    document.querySelectorAll('[data-km-pick]').forEach((a) =>
      a.addEventListener('click', (e) => {
        e.preventDefault();
        offer = Math.min(D.offers.length - 1, Number(a.dataset.kmPick) || 0);
        render();
        root.querySelector('#km-buy').scrollIntoView({ behavior: 'smooth', block: 'start' });
      })
    );

    function render() {
      [...sws.children].forEach((b, i) => b.setAttribute('aria-pressed', String(i === color)));
      root.querySelector('[data-km-colorname]').textContent = V[color].name;
      [...offs.children].forEach((b, i) => b.setAttribute('aria-checked', String(i === offer)));
      const o = D.offers[offer];
      root.querySelectorAll('[data-km-price]').forEach((el) => (el.textContent = zl(o.p)));
      const sn = root.querySelector('[data-km-sticky-n]');
      if (sn) sn.textContent = o.t;
      pk.hidden = o.q === 1;
      if (o.q > 1) {
        let h = '<div class="km-row" style="margin:0"><b style="font-size:14px">Kolor każdej łapki</b></div>';
        for (let n = 0; n < o.q; n++) {
          h += '<div class="km-picks__row"><span>Łapka ' + (n + 1) + ': <b>' + V[picks[n]].name + '</b></span><span class="km-mini">' +
            V.map((c, ci) => '<button type="button" aria-label="' + c.name + '" aria-pressed="' + (picks[n] === ci) + '" data-n="' + n + '" data-c="' + ci + '"><i style="background:' + c.hex + '"></i></button>').join('') +
            '</span></div>';
        }
        pk.innerHTML = h;
        pk.querySelectorAll('button').forEach((b) =>
          b.addEventListener('click', () => { picks[+b.dataset.n] = +b.dataset.c; render(); })
        );
      }
    }
    render();

    async function add(btn) {
      const o = D.offers[offer];
      const list = o.q === 1 ? [color] : picks.slice(0, o.q);
      const qty = {};
      list.forEach((c) => (qty[V[c].id] = (qty[V[c].id] || 0) + 1));
      const items = Object.keys(qty).map((id) => ({ id: Number(id), quantity: qty[id] }));
      err.hidden = true;
      btn.setAttribute('aria-busy', 'true');
      try {
        const r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items, sections: 'cart-drawer-section', sections_url: location.pathname }),
        });
        const res = await r.json();
        if (!r.ok) throw new Error(res.description || res.message || 'Nie udało się dodać do koszyka.');
        await refreshCart(res.sections && res.sections['cart-drawer-section']);
      } catch (e) {
        err.textContent = e.message || 'Nie udało się dodać do koszyka. Spróbuj jeszcze raz.';
        err.hidden = false;
      } finally {
        btn.removeAttribute('aria-busy');
      }
    }
    root.querySelectorAll('[data-km-atc]').forEach((b) => b.addEventListener('click', () => add(b)));

    const main = root.querySelector('.km-buy [data-km-atc]');
    if (sticky && main && 'IntersectionObserver' in window) {
      new IntersectionObserver((e) => {
        const on = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', String(!on));
        sticky.querySelector('button').tabIndex = on ? 0 : -1;
      }).observe(main);
    }
  }

  async function refreshCart(html) {
    const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
    if (html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-hydration-key="cart-drawer-inner"]');
      const cur = document.querySelector('#cart-drawer [data-hydration-key="cart-drawer-inner"]');
      if (fresh && cur) cur.replaceWith(fresh);
    }
    document.querySelectorAll('.cart-bubble__text-count, [data-cart-count]').forEach((el) => (el.textContent = cart.item_count));
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'kosmyk', data: { itemCount: cart.item_count, source: 'kosmyk' } } }));
    const drawer = document.querySelector('theme-drawer#cart-drawer');
    if (drawer && typeof drawer.open === 'function') drawer.open();
    else location.href = '/cart';
  }

  function initTabs(root) {
    const btns = root.querySelectorAll('[data-km-tab]');
    btns.forEach((b) =>
      b.addEventListener('click', () => {
        btns.forEach((x) => x.setAttribute('aria-selected', String(x === b)));
        root.querySelectorAll('[data-km-panel]').forEach((p) => (p.hidden = p.dataset.kmPanel !== b.dataset.kmTab));
      })
    );
  }

  function boot() {
    document.querySelectorAll('[data-km-product]').forEach((r) => { if (!r.dataset.kmReady) { r.dataset.kmReady = '1'; initProduct(r); } });
    document.querySelectorAll('[data-km-tabs]').forEach((r) => { if (!r.dataset.kmReady) { r.dataset.kmReady = '1'; initTabs(r); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
